import { type CompanyStore } from "services/company/companyStore";
import { GstTurnoverOptions } from "services/company/companyTypes";
import { type IssuesStore } from "services/issues/issuesStore";
import { QuestionsStore } from "services/questions/questionsStore";
import { CompanyAbnQuestion } from "./companyConstants";

export class CompanyAbnQuestionsStore extends QuestionsStore<CompanyAbnQuestion> {
  constructor(
    private readonly _companyStore: CompanyStore,
    protected readonly _issuesStore: IssuesStore,
  ) {
    super(CompanyAbnQuestion, _issuesStore);
  }

  protected _getRelevantQuestion(): CompanyAbnQuestion | undefined {
    // Return undefined to show all questions in sequence
    // Question skipping is handled by _shouldSkipQuestion() method
    return undefined;
  }

  protected _shouldSkipQuestion(question: CompanyAbnQuestion): boolean {
    const { company } = this._companyStore;
    const isGSTRequested = company?.gstRegistrationRequested ?? false;

    // Define all GST-related questions that should be skipped when GST is not requested
    const gstDependentQuestions = [
      CompanyAbnQuestion.GSTTurnover,
      CompanyAbnQuestion.GSTLodgementFrequency,
      CompanyAbnQuestion.GSTCashAccounting,
      CompanyAbnQuestion.GSTImportsGoods,
    ];

    // Skip GST-related questions if gstRegistrationRequested is false
    if (gstDependentQuestions.includes(question) && !isGSTRequested) {
      return true;
    }

    // Skip GSTLodgementFrequency if turnover is $20M+
    if (question === CompanyAbnQuestion.GSTLodgementFrequency) {
      const gstTurnover = company?.gstTurnover;
      if (gstTurnover === GstTurnoverOptions.OVER_20_MILLION) {
        return true;
      }
    }

    return super._shouldSkipQuestion(question);
  }
}
